import React, { useState } from 'react';
import { FaSpinner, FaStar } from 'react-icons/fa';
import { V2_TYPE } from '../helperV2';
import PlanUpgradeModal from './PlanUpgradeModal';
import './PlanSwitchButton.scss';

/**
 * PlanSwitchButton — Compact pill shown in the form header.
 * Displays current plan name and opens the upgrade/comparison modal on click.
 */
const PlanSwitchButton = ({
    currentType,
    disabled,
    loading = false,
    onSwitchType,
}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const isPrime = Number(currentType) === V2_TYPE.PRIME;
    const title = isPrime ? 'Business Prime' : 'Unlock Business Prime';

    return (
        <>
            <button
                type='button'
                className='plan-switch-btn'
                onClick={() => setModalOpen(true)}
                disabled={disabled || loading}
                data-testid='plan-switch-header-btn'
                title={isPrime ? 'Currently on Business Prime.' : 'See Prime benefits and upgrade options.'}
            >
                <span className='plan-switch-btn__label'>
                    {loading ? <FaSpinner size={11} className='spinner' /> : <FaStar size={11} />}
                    {loading ? 'Updating plan...' : title}
                </span>
            </button>

            <PlanUpgradeModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                currentType={currentType}
                onSwitchType={onSwitchType}
                disabled={disabled}
                loading={loading}
            />
        </>
    );
};

export default PlanSwitchButton;
